import type { SignalColor } from './wisp-lib'
import { WispSignal } from './wisp-lib'

export class WispSignalElement extends HTMLElement {
  static get observedAttributes() {
    return ['id', 'data-data', 'data-color', 'data-vertical'];
  }

  private canvas: HTMLCanvasElement | null = null;
  private data: string | undefined = undefined;
  private color: SignalColor | undefined = undefined;
  private pixelPerRow: number = this.dataset?.pixelPerRow ? Number(this.dataset.pixelPerRow) : 8;
  private vertical: boolean = this.dataset?.vertical === 'true';
  private shadow: ShadowRoot;
  public  signal: WispSignal | null = null;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.initAttributes().then(() => {
      this.initCanvas();
    });
  }

  disconnectedCallback() {
    this.destroy();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: never) {
    if (!oldValue) return;
    const attribute = name.split('-')[1];

    if (attribute === 'data') this.data = newValue;
    if (attribute === 'color') this.color = newValue;

    this.signal?.updateSignal({
      data: this.data,
      color: this.color,
      pixelPerRow: this.pixelPerRow,
    });

    this.validateAttributes();
  }

  initCanvas() {
    this.canvas = document.createElement('canvas');
    if (!this.validateAttributes()) return;
    this.signal = new WispSignal(this.canvas, this?.data ?? 'Payload not found', this?.color ?? [253, 253, 253], this.pixelPerRow, this.vertical);
    this.shadow.innerHTML = `
      <style>
        :host { display: block; }
      </style>
    `;
    this.shadow.appendChild(this.canvas);
  }

  destroy() {
    this.signal?.destroy();
  }

  async initAttributes() {
    const { data, color, pixelPerRow, vertical } = this.dataset;
    if (data) this.data = data;
    if (color) this.color = this.parseColor(color);
    if (pixelPerRow) this.pixelPerRow = Number(pixelPerRow);
    if (vertical) this.vertical = vertical === 'true';
  }

  validateAttributes() {
    return Boolean(this.data && this.color);
  }

  parseColor(colorString: string): SignalColor {
    const split = colorString.replace(/[\[\]]/g, '').split(',');
    return [Number(split[0]), Number(split[1]), Number(split[2])];
  }
}

export function defineSignalElement() {
  customElements.define('wisp-signal-element', WispSignalElement);
}